export default __webpack_public_path__ + "static/media/logo.4b745c06.svg";